import { Route, Routes } from "react-router";
import OrdersListPage from "./list";
import AddOrderPage from "./add";
import OrderViewPage from "./view";

function OrdersPage() {
	return (
		<Routes>
			<Route path="/" element={<OrdersListPage />} />
			<Route path="/add" element={<AddOrderPage />} />
			<Route path="/:id" element={<OrderViewPage />} />
		</Routes>
	);
}

export default OrdersPage;
